// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"12cd3777","505":"3bd04667"}[chunkId] + ".chunk.js";
};